import { defineComponent as t, openBlock as r, createElementBlock as o, mergeProps as s, renderSlot as n } from "vue";
import "./ghl-ui.es221.js";
const a = t({
  name: "UITextSmNormal",
  inheritAttrs: !1
}), l = t({
  ...a,
  setup(m) {
    return (e, c) => (r(), o("div", s(e.$attrs, { class: "hl-text-sm-normal" }), [
      n(e.$slots, "default")
    ], 16));
  }
}), f = l;
export {
  f as default
};
